import { nanoid } from 'nanoid';

// Generate a unique ID for various identifier purposes
export default () => nanoid(10);
